"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesSonarObjectsPostAsyncSlice = void 0;
const name_1 = require("./name.js");
const _api_1 = require("../../../api/index.js");
const get_1 = require("../summary/get.js");
const actions_1 = require("../../sonar-objects/_idMap/actions.js");
const sonar_analytics_1 = require("@sonar-software/sonar-analytics");
const xuder_1 = require("@sonar-software/xuder");
exports.coreInitiativesSonarObjectsPostAsyncSlice = (0, xuder_1.createPostAsyncSlice)({
    additionalReceiveSteps: [
        {
            actionHandler: get_1.refreshCurrentInitiativeSummarySaga,
            type: xuder_1.SagaYieldType.Every
        }
    ],
    additionalRequestSteps: [
        {
            actionHandler: (0, sonar_analytics_1.createLogSaga)(sonar_analytics_1.AMPLITUDE_EVENT.SCOPE_CHANGED, ({ data }) => ({
                action: 'added',
                sonarObjectIds: data.sonarObjectIds
            })),
            type: xuder_1.SagaYieldType.Every
        }
    ],
    httpSagaOptions: {
        successCombinationActionCreators: [
            (request) => (0, actions_1.updateSonarObjectReferences)(request.sonarObjectIds.map((sonarObjectId) => ({
                initiatives: { toAdd: request.initiativeId },
                sonarObjectId
            })))
        ]
    },
    name: name_1.CoreInitiativesSonarObjectsName,
    receive: true,
    request: true,
    requestHandler: _api_1.postInitiativeSonarObjects,
    yieldType: xuder_1.SagaYieldType.Every
});
//# sourceMappingURL=post.js.map